// extracted by mini-css-extract-plugin
export default {"header":"header_header__J8KBm","header-title":"header_header-title__hqG67","header-btn":"header_header-btn__0WI8Q"};